import { useEffect, useState } from 'react';
import api from '../utils/api';

/**
 * 待补资料提示条（2026-10-29 建立）
 *
 * 【它是什么】
 *   历史数据补录期间的过渡组件。数据补齐后（strict_data_mode=1）
 *   后端返回 hidden=true，这个组件自动消失，不用改前端。
 *
 * 【邢先生 2026-10-29 定】
 *   「现在数据都还没补充完，在这期间的问题是不是做一个单独处理机制？
 *     在所有的数据都弄好之后再删除这个」
 *
 * 【设计原则】
 *   · 不打扰：默认折叠成一行，不占版面
 *   · 可感知：数字明确，知道还差多少
 *   · 可下钻：点进去看待补明细
 *   · 零侵入：不动任何现有页面逻辑
 */
const REASON_LABEL = {
  '缺起保日期': '起保日',
  '缺到期日期': '到期日',
  '缺保费': '保费',
  '缺车主姓名': '车主',
  '缺车架号': '车架号',
  '无审验材料': '审验材料',
};

export default function DataQualityBar() {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);
  const [detail, setDetail] = useState({ type: null, items: [], total: 0, loading: false });

  useEffect(() => {
    let alive = true;
    api.get('/data-quality/summary')
      .then((r) => { if (alive) setData(r.data); })
      .catch(() => { if (alive) setData({ hidden: true }); });
    return () => { alive = false; };
  }, []);

  const loadDetail = async (type) => {
    setDetail({ type, items: [], total: 0, loading: true });
    try {
      const r = await api.get(`/data-quality/${type}?page=1&page_size=20`);
      setDetail({ type, items: r.data.items || [], total: r.data.total || 0, loading: false });
    } catch {
      setDetail({ type, items: [], total: 0, loading: false });
    }
  };

  if (!data || data.hidden || !data.total) return null;

  const blocks = [
    data.insurance?.pending && {
      key: 'insurance', label: '保单', n: data.insurance.pending,
      detail: `共 ${data.insurance.total} 条`,
      reasons: data.insurance.reasons,
    },
    data.vehicle?.pending && {
      key: 'vehicle', label: '车辆档案', n: data.vehicle.pending,
      detail: `共 ${data.vehicle.total} 台`,
      reasons: data.vehicle.reasons,
    },
    data.inspection?.no_document && {
      key: 'inspection', label: '审验材料', n: data.inspection.no_document,
      detail: '缺扫描件', reasons: { '无审验材料': data.inspection.no_document },
    },
  ].filter(Boolean);

  return (
    <div style={{
      margin: '0 0 16px', padding: '10px 14px', borderRadius: 8,
      background: '#fffbe6', border: '1px solid #ffe58f', fontSize: 13,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
        <span style={{ color: '#d48806', fontWeight: 600 }}>📋 待补资料</span>
        {blocks.map((b) => (
          <span key={b.key} style={{
            padding: '2px 8px', background: '#fff', border: '1px solid #ffe58f',
            borderRadius: 4, cursor: 'pointer',
          }} onClick={() => { setOpen(true); loadDetail(b.key); }}>
            {b.label} <b style={{ color: '#cf1322' }}>{b.n}</b>
          </span>
        ))}
        <span style={{ color: '#8c8c8c', marginLeft: 'auto' }}>
          数据补录期间的临时提示，补齐后可下线
        </span>
      </div>

      {open && (
        <div style={{ marginTop: 12, background: '#fff', borderRadius: 6, padding: 12 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
            <b>待补明细</b>
            <span style={{ cursor: 'pointer', color: '#8c8c8c' }} onClick={() => setOpen(false)}>✕</span>
          </div>
          {detail.loading ? (
            <div style={{ color: '#8c8c8c' }}>加载中…</div>
          ) : (
            <>
              <div style={{ color: '#8c8c8c', marginBottom: 8 }}>
                共 <b>{detail.total}</b> 条，显示前 {detail.items.length} 条
              </div>
              <table style={{ width: '100%', fontSize: 12, borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ background: '#fafafa', textAlign: 'left' }}>
                    <th style={{ padding: 6 }}>车牌</th>
                    <th style={{ padding: 6 }}>类型</th>
                    <th style={{ padding: 6 }}>缺什么</th>
                  </tr>
                </thead>
                <tbody>
                  {detail.items.map((it, i) => (
                    <tr key={i} style={{ borderTop: '1px solid #f0f0f0' }}>
                      <td style={{ padding: 6 }}>{it.plate_number || '-'}</td>
                      <td style={{ padding: 6 }}>
                        {it.insurance_type || (it.inspect_date ? `审验 ${it.inspect_date}` : '-')}
                      </td>
                      <td style={{ padding: 6, color: '#cf1322' }}>
                        {(it.reasons || []).map((r) => REASON_LABEL[r] || r).join(' / ')}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}
        </div>
      )}
    </div>
  );
}
